import { ActionField } from "src/api/client-api/ActionPlan/ActionPlanAction/useGetOneActionPlanAction";
import { PostElement } from "src/api/client-api/post/postSchema";
import { getActionFieldsTargetProperties, isUnitlessAbbreviation } from "../../../ImpactSection/utils";

export type FieldStartingValue = {
    propertyId: number;
    label: string;
    value: string;
    unit: string | undefined;
};

export const getFieldStartingValues = (
    field: ActionField,
    startingElements: Pick<PostElement, "ssqPropertyId" | "position" | "value">[],
    position: number,
): FieldStartingValue[] => {
    const seenPropertyIds = new Set<number>();

    return getActionFieldsTargetProperties([field]).flatMap((property) => {
        if (seenPropertyIds.has(property.id)) return [];
        seenPropertyIds.add(property.id);

        const value = startingElements.find(
            (element) => element.ssqPropertyId === property.id && element.position === position,
        )?.value;
        const numericValue = Number(value);
        if (value === undefined || !Number.isFinite(numericValue) || numericValue === 0) return [];

        const abbreviation = property.unit?.abbreviation;
        const unit = isUnitlessAbbreviation(abbreviation) ? undefined : abbreviation;

        return [{ propertyId: property.id, label: property.name || property.title, value, unit }];
    });
};
